import gql from 'graphql-tag';

export const GetLicensedProductsQuery = gql`
	query GetLicensedProducts {
		tenantContext {
			licensedProducts {
				licenseStatus
				productKey
			}
		}
	}
`;
